import { render, staticRenderFns } from "./SelectText.vue?vue&type=template&id=f6587244&scoped=true"
import script from "./SelectText.vue?vue&type=script&lang=js"
export * from "./SelectText.vue?vue&type=script&lang=js"
import style0 from "./SelectText.vue?vue&type=style&index=0&id=f6587244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6587244",
  null
  
)

export default component.exports